import { HugeiconsIcon } from '@hugeicons/react';
import { UserAiIcon } from '@hugeicons/core-free-icons';
import styles from './AssistantSidebar.module.scss';

export const AssistantSidebarCollapsed = ({ onExpand }) => {
	return (
		<button className={styles.collapsedBar} onClick={onExpand} aria-label="Open assistant">
			<HugeiconsIcon icon={UserAiIcon} className={styles.assistantIcon} size={24} />
		</button>
	);
};
